export default __webpack_public_path__ + "assets/images/df0a7ff091bdbd3611f4ca83dc6b25ca-pending_icon_elo.svg";